import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { MapBreakFormComponent } from '../app/map-break-form/map-break-form.component';
import { NotFoundComponent } from './not-found/not-found.component';

const routes: Routes = [
  { path: '', component: MapBreakFormComponent },
  { path: '**', component: NotFoundComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
